"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _reactRedux = require("react-redux");

var _gift = require("../../store/gift/gift.selector");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    details: {
      marginTop: spacing(2),
      borderTopWidth: 1,
      borderTopStyle: 'solid',
      borderTopColor: palette.divider,
      padding: spacing(2),
      paddingLeft: 0
    },
    row: {
      marginTop: spacing(2)
    },
    firstRow: {
      marginTop: 0
    },
    title: {
      width: 70
    }
  };
});

var ProductDetailsForm = function ProductDetailsForm(_ref2) {
  var product = _ref2.product;
  var productOptions = (0, _reactRedux.useSelector)(_gift.getGiftSelectedOptions);
  var deliveryTracking = (0, _reactRedux.useSelector)(_gift.getGiftDeliveryTracking);
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    className: classes.details
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "row",
    alignItems: "center",
    className: (0, _classnames.default)(classes.row, classes.firstRow)
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: (0, _classnames.default)('Body-Small-Inactive', classes.title)
  }, "Cost:"), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Small-Static"
  }, "$", /*#__PURE__*/_react.default.createElement(_ui.NumberFormat, null, product.price))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "row",
    alignItems: "center",
    className: classes.row
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: (0, _classnames.default)('Body-Small-Inactive', classes.title)
  }, "From:"), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Small-Static"
  }, product.vendor_name)), deliveryTracking && /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "row",
    alignItems: "center",
    className: classes.row
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: (0, _classnames.default)('Body-Small-Inactive', classes.title)
  }, "Tracking:"), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Small-Link"
  }, /*#__PURE__*/_react.default.createElement(_material.Link, {
    target: "_blank",
    href: deliveryTracking.link
  }, deliveryTracking.status))), productOptions && productOptions.length > 0 && productOptions.map(function (option) {
    return /*#__PURE__*/_react.default.createElement(_material.Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      className: classes.row
    }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
      className: (0, _classnames.default)('Body-Small-Inactive', classes.title)
    }, option.attribute, ":"), /*#__PURE__*/_react.default.createElement(_material.Typography, {
      className: "Body-Small-Static"
    }, option.value));
  }));
};

ProductDetailsForm.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  product: _propTypes.default.object.isRequired
};
var _default = ProductDetailsForm;
exports.default = _default;